export const imagesRotationDelay = 5000;